import { combineReducers } from 'redux';

import pageLayout from './page-layout';
import portal from './portal';

export default combineReducers({
  pageLayout,
  portal
});
